import routerPageStack from "../reducers/router-page-stack";

export const RouterPageStackSelector = {
  state: (state) => state[routerPageStack.name],
  pageStack: (state) => RouterPageStackSelector.state(state).pageStack,
};
